import { render } from "./RuleInspectorDialog.vue?vue&type=template&id=43f5cd75&scoped=true"
import script from "./RuleInspectorDialog.vue?vue&type=script&lang=js"
export * from "./RuleInspectorDialog.vue?vue&type=script&lang=js"

import "./RuleInspectorDialog.vue?vue&type=style&index=0&id=43f5cd75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f5cd75"]])

export default __exports__